export default "__VITE_ASSET__BrFMhXs2__"